module.exports = "/_next/static/images/sn-5a3a015cf030a34538ebf3d2f6a3f1db.svg";